import { useEffect, useRef, useState } from "react"

export function LandingAnimatedBrackyBreakout() {
  const [isVisible, setIsVisible] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return
        setIsVisible(entry.isIntersecting)
      },
      {
        rootMargin: "300px", // Start loading 300px before entering viewport for smooth animation
        threshold: 0.1, // Trigger when 10% visible
      },
    )

    if (containerRef.current) {
      observer.observe(containerRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <div
      className="flex justify-center mb-0 sm:-mb-1 md:mb-[1.7rem] mdlg:mb-[2.7rem] xl:mb-11 2xl:mb-[3.8rem] relative isolate z-300 scale-[.97] md:scale-[1.13] mdlg:scale-[1.2] lg:scale-[1.25] xl:scale-[1.32] 2xl:scale-[1.415]"
      ref={containerRef}
    >
      <div className="relative inline-block isolate z-301">
        {/* Only render GIFs when component is visible */}
        {isVisible && (
          <>
            {/* Galaxy GIF background - positioned behind everything */}
            <div
              className="absolute inset-0 opacity-70 blur-xs mix-blend-screen pointer-events-none select-none z-302"
              style={{
                left: "50%",
                top: "50%",
                transform: "translate(-52%, -49%)",
                width: "min(415px, 130%)",
                height: "min(415px, 130%)",
                backgroundImage: "url(https://a.bracky.app/assets/landing/backgrounds/bracky-breakout-galaxy-3.gif)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                maskImage: "radial-gradient(circle, black 50%, transparent 65%)",
                maskSize: "100% 100%",
                WebkitMaskSize: "100% 100%",
                maskRepeat: "no-repeat",
                WebkitMaskRepeat: "no-repeat",
                maskPosition: "center",
                WebkitMaskPosition: "center",
              }}
            />
            {/* Warp rays GIF background - positioned behind Bracky and masked into circle */}
            <div
              className="absolute inset-0 blur-[.5px] opacity-70 pointer-events-none select-none mix-blend-overlay z-303"
              style={{
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                width: "min(280px, 90%)",
                height: "min(280px, 90%)",
                backgroundImage:
                  "url(https://a.bracky.app/assets/landing/backgrounds/assets_landing_backgrounds_bracky-breakout-warp-rays.mp4)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                maskImage: "radial-gradient(circle, black 60%, transparent 70%)",
                WebkitMaskImage: "radial-gradient(circle, black 60%, transparent 70%)",
                maskSize: "100% 100%",
                WebkitMaskSize: "100% 100%",
                maskRepeat: "no-repeat",
                WebkitMaskRepeat: "no-repeat",
                maskPosition: "center",
                WebkitMaskPosition: "center",
              }}
            />
            {/* Inner flame GIF background - positioned on top of everything except core illustration */}
            <div
              className="absolute inset-0 opacity-35 mix-blend-overlay pointer-events-none select-none z-304"
              style={{
                left: "50%",
                top: "50%",
                transform: "translate(-54%, -48%)",
                width: "min(275px, 85%)",
                height: "min(275px, 85%)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundImage: "url(https://a.bracky.app/assets/landing/backgrounds/bracky-breakout-inner-flame.gif)",
                maskImage: "radial-gradient(circle, black 50%, transparent 65%)",
                WebkitMaskImage: "radial-gradient(circle, black 50%, transparent 65%)",
                maskSize: "100% 100%",
                WebkitMaskSize: "100% 100%",
                maskRepeat: "no-repeat",
                WebkitMaskRepeat: "no-repeat",
                maskPosition: "center",
                WebkitMaskPosition: "center",
              }}
            />
          </>
        )}
        <img
          src="https://a.bracky.app/assets/landing/backgrounds/bracky-breakout-300.webp"
          alt="Bracky breakout background"
          className="max-w-[80.6%] md:w-98 translate-y-[.5rem] md:translate-y-0 mb-0 block mx-auto select-none pointer-events-none relative z-305 isolate"
          draggable="false"
          loading="lazy"
        />
        {/* Bracky's Breakout Illustration ;) */}
        {isVisible && (
          <div
            className="absolute inset-0 pointer-events-none opacity-40 mix-blend-overlay z-306"
            style={{
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
              height: "100%",
              maskImage: "url(https://a.bracky.app/assets/landing/backgrounds/bracky-breakout-5.webp)",
              maskSize: "contain",
              maskRepeat: "no-repeat",
              maskPosition: "center",
              WebkitMaskImage: "url(https://a.bracky.app/assets/landing/backgrounds/bracky-breakout-5.webp)",
              WebkitMaskSize: "contain",
              WebkitMaskRepeat: "no-repeat",
              WebkitMaskPosition: "center",
            }}
          />
        )}
      </div>
    </div>
  )
}
